<div class="page-main-header container-fluid">
    <div class="main-header-right row">
        <div class="main-header-left text-center col-lg-3">
            <div class="logo-wrapper">
                <a href="javascript:void(0)" routerLink="/">
                    <img src="assets/images/logo/NewLogo.png" alt="" /></a>
            </div>
        </div>
        <div class="col-lg-3"></div>
        <div class="main-header-left text-center col-lg-6">
            <div class="logo-wrapper">
                <a href="javascript:void(0)" routerLink="/">
                    <img src="assets/images/logo/logo2.png" alt="" /></a>
            </div>
        </div>
        <div class="mobile-sidebar">
            <div class="flex-grow-1 text-end switch-sm">
            </div>
        </div>
        <div class="vertical-mobile-sidebar">
            <i class="fa fa-bars sidebar-bar"> </i>
        </div>
        <div class="nav-right col pull-right right-menu">
            <div class="d-lg-none mobile-toggle pull-right">
                <app-feather-icons [icon]="'more-horizontal'" (click)="openMobileNav()"></app-feather-icons>
            </div>
        </div>
    </div>
</div>

<div class="card-header h5 text-white bg-primary ">
    <div class="row">
        <div class="col-10">
            <h4 class="heading text-2xl font-bold ms-5 mt-2">Features</h4>
        </div>
        <!-- <div class="col-2">
            <button (click)="addedit()" class="btn btn-xl text-dark float-right"><i
                    class="fa fa-reply"></i>&nbsp;<b>Back</b></button>
        </div> -->
    </div>
</div>
<div class="container">
    <div class="cards">
        <div class="card content" *ngFor="let Data of eventData" (click)="checkEvent(Data._id)">
            <div class="card-content">
                <div class="card-img">
                    <img src="{{Data.image}}" class="card-img-top" alt="Pineapple">
                </div>
                <div class="card-label">{{Data.institutionName}}</div>
                <div class="card-title">
                    {{Data.title}}
                    <p>
                        {{Data.date}}
                    </p>
                </div>
            </div>
        </div>
        <!-- <div class="col-12 my-auto" *ngIf="!addbutton ">
            <div class="text-heading text-center font-weight-bold mb-3">
                <span class=" text-primary display-4"><i class="icon-exclamation icons"></i></span>
                <p style="font-size: larger;color: #f05968;
          font-weight: 800; margin-top:40px; text-align : center">No Blogs Recommended Here! </p>
            </div>
        </div> -->
    </div>
    <div *ngIf="error">
        <p class="notCreated ">No Features Recommended Here! </p>
    </div>
    <!-- ---pagination-starts -->
    <div class="row mt-5" *ngIf="!error">
        <div class="col-4 ps-5" *ngIf="pagebutton"></div>
        <div class="col-4 ps-5" *ngIf="!pagebutton">
            <input class="form-control w-100" type="number" min="1" [(ngModel)]="searchPage"
                placeholder="Search By page no" (change)="searchPageno()" />
            <p *ngIf="isPageAvailable" class="text-danger text-center fs-6">Page Not Found!</p>
        </div>
        <div class="col-md-4">
            <div class="data-list">
                <p>
                    Showing {{ startIndex + 1 }} - {{ endIndex }} of {{ count }} records
                </p>
            </div>
        </div>
        <div class="col-md-4">
            <select id="showPageType" class="form-control page-dropdown" type="text" [(ngModel)]="pageValue"
                (change)="onChangePagination($event)">
                <option *ngFor="let data of showPageType" [value]="data.id">
                    {{ data.value }}
                </option>
            </select>
        </div>
    </div>
    <div class="row justify-content-center mt-3" *ngIf="!error">
        <div class="col-md-4">
            <div class="pagination-controls d-flex justify-content-center me-5 w-100" *ngIf="!pagebutton">
                <button class=" btn btn-primary-new d-flex align-items-center justify-content-center text-white"
                    (click)="previousPage()" [disabled]="currentPage === 1">
                    << </button>
                        <button class="btn-primary-new btn text-white" *ngFor="let page of pages"
                            [ngClass]="{ active: currentPage === page }" (click)="goToPage(page)"
                            [disabled]="page === '...'">
                            {{ page }}
                        </button>
                        <button class="btn btn-primary-new d-flex align-items-center justify-content-center text-white"
                            (click)="nextPage()" [disabled]="currentPage === totalPages">
                            >>
                        </button>
            </div>
        </div>
    </div>
    <!-- Pagination Close -->
</div>